import { h, Component } from 'preact'
import Dropdown from '../dropdown/index'
import Phrase from '../../libs/translationsUtils/phrase'
import Icon from '../assets/index'

interface ProductAreaType {
  id: number
  name: string
}

interface Props {
  allProductAreas: ProductAreaType[]
}

interface State {
  selectedProductArea: ProductAreaType | null
}

class ProductAreaSelect extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      selectedProductArea: null
    }
  }

  componentDidMount () {
  }

  render ({ allProductAreas }: Props, { selectedProductArea }: State) {
    return (
      <div>
        {
          selectedProductArea
            ? (
              <input type='hidden' name='topic[productAreas]' id='topic_product-areas' value={selectedProductArea.id} />
              )
            : null
        }
        <Dropdown
          closeOnDropdownClick
          popupName='product-area-selector'
          class='product-area-selector'
          trigger={<div>{selectedProductArea !== null ? <span> {selectedProductArea.name} </span> : <Phrase p='select.product.area' />} <Icon icon='arrowDropdown' /></div>}
          triggerClass='product-area-selector-wrapper'
        >
          <li onClick={() => this.setState({ selectedProductArea: null })} className='product-area-item'>
            <Phrase p='select.product.area' />
          </li>
          {
            allProductAreas.map(productArea => (
              <li
                key={productArea.id}
                className='product-area-item'
                onClick={() => this.setState({ selectedProductArea: productArea })}
              >{productArea.name}</li>
            ))
          }
        </Dropdown>
      </div>
    )
  }
}
export default ProductAreaSelect
